import styled, { css } from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import { Text } from '../Text/Text.es.js';
import { palette, spacing, variant } from '../../utils/theme.es.js';

const sizeStyles = variant({
  prop: "size",
  variants: {
    md: {
      width: spacing(4),
      height: spacing(4)
    },
    lg: {
      width: spacing(6),
      height: spacing(6)
    }
  }
});
const Control = styled(Box).attrs(() => ({ ariaHidden: true }))`
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    border: 1px solid ${palette("neutral.600")};
    border-radius: 100em;
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
    transition: opacity 200ms ease-in;
    color: ${palette("primary.500")};
`;
Control.displayName = "Radio.Control";
const Label = styled(Text)`
    margin-left: ${spacing("xs")};
    user-select: none;
`;
Label.displayName = "Radio.Label";
const Radio = styled(Box).attrs(() => ({ as: "label" }))`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: ${spacing("xs")};

    &:hover {
        cursor: ${({ isDisabled }) => isDisabled ? "not-allowed" : "pointer"};
    }

    input[type='radio']:checked ~ ${Control} {
        background-color: ${palette("primary.500")};
        border-color: ${palette("primary.500")};

        &:before {
            content: '';
            width: 50%;
            height: 50%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate3d(-50%, -50%, 0);
            border-radius: 100em;
            background-color: ${palette("neutral.0")};
        }
    }

    input[type='radio']:disabled ~ ${Control} {
        background-color: ${palette("neutral.500")};
        border-color: ${palette("neutral.500")};
    }

    ${Control} {
        ${sizeStyles}

        ${({ isInvalid }) => isInvalid && css`
                border-color: ${palette("danger.500")};
            `};
    }
`;
Radio.displayName = "Radio";

export { Control, Label, Radio };
//# sourceMappingURL=styled.es.js.map
